export default window._cmsContent['solar/when-get-solar']